module.exports = __webpack_public_path__ + "static/media/agency-pricing-hero.58d9a8b6.svg";